"use client";

import Image from "next/image";
import React, { useState, useEffect } from "react";
import MachineDescription from "../MachineDescription";
import MachineHeading from "../MachineHeading";
import MachineDeckSelector from "../MachineDeckSelector";
import MachineManuals from "../MachineManuals";
import MachineSpecs from "../MachineSpecs";
import SizeChanger from "../SizeChanger";

export default function Model(props) {
  const machine = props.data;
  const decks = props.data.decks;
  let types = new Set(decks.map((machine) => machine.type));
  types = Array.from(types); // Convert back to array
  const [deckTypeImage, setDeckTypeImage] = useState(() => {
    const diskDeck = machine.decks.find(
      (deck) => deck.type.data.attributes.type === "Disk - 3b"
    );
    return diskDeck
      ? diskDeck.type.data.attributes.image.data.attributes.url
      : "";
  });
  const [selectedDeckDescription, setSelectedDeckDescription] = useState(() => {
    const diskDeck = machine.decks.find(
      (deck) => deck.type.data.attributes.type === "Disk - 3b"
    );
    return diskDeck ? diskDeck.type.data.attributes.description : "";
  });
  const [selectedDeckType, setSelectedDeckType] = useState(() => {
    const diskDeck = decks.find(
      (deck) => deck.type.data.attributes.type === "Disk - 3b"
    );
    if(decks.length === 1 ) {
      return decks ? decks[0].type.data.attributes.type : null
    }
    return diskDeck ? "Disk - 3b" : "";
  });
  const [selectedDeckImage, setSelectedDeckImage] = useState(() => {
    const diskDeck = decks.find(
      (deck) => deck.type.data.attributes.type === "Disk - 3b"
    );
    return diskDeck
      ? diskDeck.image.data.attributes.url
      : machine.main_image.data.attributes.url;
  });
  const [selectedThumbNails, setSelectedThumbNails] = useState(() => {
    const diskDeck = decks.find(
      (deck) => deck.type.data.attributes.type === "Disk - 3b"
    );
    if(decks.length === 1  ) {
      return decks ? decks[0].thumbs.data : null
    }

    return diskDeck ? diskDeck.thumbs.data : null;
  });

  useEffect(() => {
    setSelectedDeckImage(() => {
      const diskDeck = decks.find(
        (deck) => deck.type.data.attributes.type === "Disk - 3b"
      );
      return diskDeck
        ? diskDeck.image.data.attributes.url
        : machine.main_image.data.attributes.url;
    });
    setSelectedDeckType(() => {
      const diskDeck = decks.find(
        (deck) => deck.type.data.attributes.type === "Disk - 3b"
      );
      return diskDeck ? "Disk - 3b" : "";
    });
    setSelectedDeckDescription(() => {
      const diskDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === "Disk - 3b"
      );
      if(decks.length === 1) {
        return decks ? decks[0].type.data.attributes.description : ""
      }
      return diskDeck ? diskDeck.type.data.attributes.description : "";
    });
    setDeckTypeImage(() => {
      const diskDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === "Disk - 3b"
      );
      return diskDeck
        ? diskDeck.type.data.attributes.image.data.attributes.url
        : "";
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  const diskWithSmallestSize =
  decks?.length > 0 && decks.filter(deck => deck.type?.data?.attributes?.type === "Disk - 3b").length > 0
    ? decks
        .filter(deck => deck.type?.data?.attributes?.type === "Disk - 3b")
        .reduce((prev, current) => {
          if (!prev.size || !current.size) {
            return prev; // Return previous if size is missing
          }
          return parseInt(current.size) < parseInt(prev.size) ? current : prev;
        })
    : null;



  const sizeLabel = diskWithSmallestSize
    ? diskWithSmallestSize.size + diskWithSmallestSize.label
    : null;

  const [selectedDeckSize, setSelectedDeckSize] = useState(sizeLabel);

  const handleSelectedDeckSize = (deck) => {
    setSelectedDeckSize(deck.size + deck.label);
    setSelectedDeckImage(deck.image.data.attributes.url);
  };
  const handleSelectedDeckType = (data) => {
    let deck = data.attributes;
    setSelectedDeckType(data);
    // Find the smallest size with the selected deck type
    const filteredDecks = machine.decks.filter(
      (machineDeck) => machineDeck.type.data.attributes.type === data
    );
    const smallestDeck = filteredDecks.reduce((smallest, current) => {
      const smallestSize = parseInt(smallest.size);
      const currentSize = parseInt(current.size);
      return currentSize < smallestSize ? current : smallest;
    });
    setDeckTypeImage(() => {
      const matchingDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === data
      );
      return matchingDeck
        ? matchingDeck.type.data.attributes.image.data.attributes.url
        : "null";
    });
    setSelectedThumbNails(() => {
      const matchingDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === data
      );
      return matchingDeck ? matchingDeck.thumbs.data : null;
    });
    setSelectedDeckDescription(() => {
      const matchingDeck = machine.decks.find(
        (deck) => deck.type.data.attributes.type === data
      );
      return matchingDeck
        ? matchingDeck.type.data.attributes.description
        : "null";
    });
    setSelectedDeckSize(smallestDeck.size + smallestDeck.label);
    setSelectedDeckImage(smallestDeck.image.data.attributes.url);
  };

  const uniqueDeckTypes = Array.from(
    new Set(machine.decks.map((item) => item.type.data.id))
  ).map((id) => {
    return machine.decks.find((item) => item.type.data.id === id);
  });
  return (
    <>
      <div className="main-section-wrapper">
        <div className="image-thumb-changer-wrapper">
          <div className="thumbs-image-wrapper">
            <div className="image-wrapper">
              <Image
                src={selectedDeckImage}
                width={500}
                height={500}
                alt={machine.name + " " + selectedDeckType}
                priority
              />
              <SizeChanger data={machine} />
            </div>
            <div className="thumbnails-wrapper">
              {selectedThumbNails?.length > 0 &&
                selectedThumbNails.map((image) => (
                  <div
                    className="thumb"
                    key={image.id}
                    onClick={() => setSelectedDeckImage(image.attributes.url)}
                  >
                    <Image
                      src={image.attributes.url}
                      width={100}
                      height={100}
                      alt={machine.name}
                      priority
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="details-section-wrapper">
          <MachineHeading
            machine={machine}
            selectedDeckType={selectedDeckType}
          />
          <MachineSpecs machine={machine} />
          <MachineDescription machine={machine} />
          <MachineDeckSelector
            machine={machine}
            handleSelectedDeckType={handleSelectedDeckType}
            deckTypeImage={deckTypeImage}
            uniqueDeckTypes={uniqueDeckTypes}
          />
          <MachineManuals machine={machine} />
        </div>
      </div>
    </>
  );
}
